import { FunctionComponent, useState, useEffect } from "react";
import "./PatientInfo.css";
import editIcon from '../../assets/icons/edit.svg';
import 'react-toastify/dist/ReactToastify.css';
import Card from "../../atoms/CardV2/Card";
import { RiUserLine } from "react-icons/ri";
import Button from "../../atoms/Button/Button";
import Input from "../../atoms/Input/Input";

interface InfoProps {
  patientDetails: any;
  onSave?: (updatedDetails: any, userType:any) => void;
}

const PatientInfo: FunctionComponent<InfoProps> = ({ patientDetails, onSave }) => {

  const [editedDetails, setEditedDetails] = useState<any>({});
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (patientDetails) {
      setEditedDetails(patientDetails)
    }
  }, [patientDetails])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditedDetails({ ...editedDetails, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    try {
      onSave?.(editedDetails, "Patient");
    } catch (error) {
    }
  }

  return (
    <Card
      title="Patient Info"
      titleIcon={<RiUserLine size={24} />}
      fullWidth={true}
      actionComponent={
        <Button variant="text" color="info" onClick={handleSave}>
          <img src={editIcon} alt="edit" />
          <span>{isSaving ? "Saving..." : "Save"}</span>
        </Button>
      }
    >
      <div className="patient-info-content">
        <Input
          label="Name*"
          name="patient_name"
          value={editedDetails.patient_name || ""}
          placeholder="Enter Name"
          onChange={handleChange}
        />
        <Input
          label="Phone Number*"
          name="patient_contact_no"
          value={editedDetails.patient_contact_no || ""}
          placeholder="Enter Number"
          onChange={handleChange}
        />
        <Input
          label="Gender*"
          name="patient_gender"
          value={(editedDetails.patient_gender === "F" ? "Female" : (editedDetails.patient_gender === "M" ? "Male" : ""))}
          placeholder="Enter Gender"
          onChange={handleChange}
        />
        <Input
          label="Date of Birth*"
          name="patient_dob"
          value={editedDetails.patient_dob || ""}
          placeholder="Enter Date of birth"
          onChange={handleChange}
        />
        <Input
          label="Height*"
          name="patient_height"
          value={editedDetails.patient_height || ""}
          placeholder="Enter Height"
          onChange={handleChange}
        />
        <Input
          label="Weight*"
          name="patient_weight"
          value={editedDetails.patient_weight || ""}
          placeholder="Enter Weight"
          onChange={handleChange}
        />
        <Input
          label="Email Address*"
          name="patient_email"
          value={editedDetails.patient_email || ""}
          placeholder="Enter Email"
          onChange={handleChange}
        />
        <Input
          label="Address*"
          name="patient_address"
          value={editedDetails.patient_address || ""}
          placeholder="Enter Address"
          onChange={handleChange}
        />
      </div>
    </Card>
  );
};

export default PatientInfo;
